module.exports = __webpack_public_path__ + "static/media/icon_med.86d92efa.svg";